import { DeliveryPoint } from '../../delivery-points/types/delivery-point.type';
import { DeliveryPointDetailsAddress } from '../../delivery-points/types/delivery-point-details.type';
import { DeliveryAddress } from '../types/delivery-selection.type';

type DeliveryPointWithAddress = Pick<DeliveryPoint, 'id'> & { address: DeliveryPointDetailsAddress };

export const deliveryPointToDeliveryAddress = (deliveryPoint: DeliveryPointWithAddress): DeliveryAddress => ({
  type: 'relay',
  _id: deliveryPoint.id,
  address: deliveryPoint.address.street,
  zipCode: deliveryPoint.address.zipCode,
  city: deliveryPoint.address.city,
  complement: deliveryPoint.address.informations,
  comment: deliveryPoint.address.comment,
});
